import { Box, Typography, useTheme } from "@mui/material"

export default function GroupHeading({ heading }: { heading: string }): JSX.Element {
    const theme = useTheme()

    return (
        <Box
            sx={{
                padding: { xs: "15px 15px 3px 15px", md: "20px 20px 5px 20px" },
                display: "flex",
                alignItems: "center"
            }}
        >
            <Typography
                variant="body_500"
                sx={{ color: theme.palette.text.secondary }}
            >
                {heading}
            </Typography>
        </Box>
    )
}